import React from 'react'
import { Content as HeaderContent } from './Header'
import { Content as BodyContent } from './Body'
import * as styles from './styles.module.scss'

/**
 *
 */
const Container = ({ children }) => (
  <div className={styles.Container}>{children}</div>
)

/**
 *
 */
const Header = () => {
  return (
    <div>
      <HeaderContent />
    </div>
  )
}

const Body = ({ data }) => {
  return (
    <div>
      <BodyContent data={data} />
    </div>
  )
}

/**
 *
 */
export const Content = ({ data }) => {
  return (
    <Container>
      <Header />
      <Body data={data} />
    </Container>
  )
}
